module.exports = __webpack_public_path__ + "models/exterior_mobile_e4068e3931c23fcc19263aff910fbec5.glb";